import { render, staticRenderFns } from "./LayoutPlan.vue?vue&type=template&id=4a9897f6&scoped=true&"
import script from "./LayoutPlan.vue?vue&type=script&lang=ts&"
export * from "./LayoutPlan.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutPlan.vue?vue&type=style&index=0&id=4a9897f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9897f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VImg,VResponsive})
